
export default {
  meta: {
    seo: {
      title: 'shop.title',
      description: 'shop.description'
    }
  }
}
